// import React from 'react';
// import { Link } from 'react-router-dom';
// import './HomePage.css';

// function HomePage() {
//   return (
//     <div className="home-page">
//       <h1>Welcome to Crop Planning App</h1>
//       <p>Prevent oversupply and losses with AI-based crop planning!</p>
//       <Link to="/select-crop">
//         <button className="select-crop-button">Select Crop</button>
//       </Link>
//     </div>
//   );
// }

// export default HomePage;

// -----------------------------------------------------------------

// import React, {useEffect, useState} from 'react';
import React from 'react';
import { Link } from 'react-router-dom';
import './HomePage.css';


function HomePage() {



  // const fullText = "Welcome to CropSage";
  // const typingSpeed = 100;
  // const initialTypeDuration = 3000;


  // useEffect(() => {
  //   let currentIndex = fullText.length;

  //   const animateText = () => {
  //     if (currentIndex >= 0) {
  //       setText(fullText.slice(currentIndex, fullText.length));
  //       currentIndex--;
  //       setTimeout(animateText, typingSpeed);
  //     } else {
  //       setTimeout(() => {
  //         currentIndex = 0;
  //         reverseText();
  //       }, initialTypeDuration);
  //     }
  //   };

  //   const reverseText = () => {
  //     if (currentIndex < fullText.length) {
  //       setText(fullText.slice(currentIndex, fullText.length));
  //       currentIndex++;
  //       setTimeout(reverseText, typingSpeed);
  //     } else {
  //       currentIndex = fullText.length;
  //       animateText();
  //     }
  //   };

  //   setTimeout(() => {
  //     animateText();
  //   }, typingSpeed);

  //   return () => {
  //     currentIndex = fullText.length;
  //   };
  // }, []);



  return (
    <div className="home-page">
      <nav>
        <ul>
          <li><a href="#about">About</a></li>
          <li><a href="#app-info">App Info</a></li>
        </ul>
      </nav>
      <div className="header">
        <h1 id="heading" style={{color:'red', fontsize:"50px", height: '70px', overflow: 'hidden' }}>Welcome To CropSage</h1>
        <p style={{fontSize:"25px"}}>Stabilize and improve farm produce rates in India!</p>
      </div>
      
      <div className="content-boxes" id="video-demo">
        <h2>Watch Our Demo Video</h2>
        <p>See how CropSage helps farmers plan better and make smarter decisions.</p>
        <div className="video-player-wrapper">
          <a
            href="https://youtu.be/oV84570bTIg?si=M9omwCIFS5pBg0eP"
            target="_blank"
            rel="noopener noreferrer"
            className="video-open-link"
            aria-label="Open video on YouTube"
          >
            <span aria-hidden="true">↗</span>
          </a>
          <iframe
            className="video-iframe"
            src="https://www.youtube.com/embed/oV84570bTIg?autoplay=1&mute=1&playsinline=1&controls=1&rel=0"
            title="CropSage demo video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </div>
      </div>

      <div className="content-boxes" id="about">
        <h2>About Our App</h2>
        <p>
          Our Crop Planning App uses advanced artificial intelligence to help farmers make better decisions about crop planting. Say goodbye to oversupply and drastic price falls. With our app, you can:
        </p>
        <ul>
          <li>Get real-time data about the current extent of a chosen crop's plantation in acres.</li>
          <li>Discover the annual demand for the crop.</li>
        </ul>
      </div>
      <div className="content-boxes" id="app-info">
        <h2>App Features</h2>
        <ul>
          <li>The AI app suggests the optimal time period for plantation in order to fetch better prices.</li>
          <li>Predict expected crop rates based on the data.</li>
        </ul>
      </div>
      <Link to="/select-crop">
        <button className="select-crop-button">Select Crop</button>
      </Link>
      <br />
      <div className="footer">
        <h3>Contact Us:</h3>
        <p><b>subodhssathe@gmail.com</b></p>
        <h3 id='copyright'>CropSage&copy;2026</h3>
      </div>
    </div>
    
  );
}

export default HomePage;
